<template>
    <div>
      <div class="action-buttons ">
        <div class="left-buttons mar-rt-10">
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group">
              <label>{{ $t('gestiune.locatie') }}</label>
              <select class="form-control" v-model="selectedLocation" :disabled="loading">
                <option :value="null">Selectează</option>
                <optgroup
                  v-for="group in groupedLocations"
                  :key="group.vat"
                  :label="`VAT: ${group.vat} — Locații: ${group.locations.map(l => l.name).join(', ')}`"
                >
                  <option
                    v-for="loc in group.locations"
                    :key="loc.id"
                    :value="loc"
                  >
                    {{ loc.name }}
                  </option>
                </optgroup>
              </select>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group" style="display: grid; margin-top: 15px;">
              <label>{{ $t('invoice.series') }}</label>
              <el-input v-model="filter.series" @input="onSeriesInput" ref="seriesInput" :disabled="loading" placeholder="Introdu seria facturii"></el-input>
            </div>
          </div>
          <div class="search-button-reports">
            <button
                :title="$t('reports.search')"
                class="btn add mar-rt-10"
                @click="onSearch"
            >
                <i class="ti-search"></i>
                <span>{{ $t('general.search') }}</span>
            </button>
          </div>
         </div>
         <div class="right-buttons">
            <button class="btn add mar-rt-10"  @click.prevent="addInvoice" :title="$t('general.add') + ' ' + $t('settingUsers.single')">
              <img src="/static/img/icons/add.png">
              {{$t('invoice.addInvoice')}}
            </button>
            <button class="btn spv-fetch mar-rt-10" @click.prevent="fetchSpvInboxMessages" :title="$t('gestiune.fetchSpvMessages')">
              {{$t('gestiune.fetchSpvMessages')}}
            </button>
            <!-- <button class="btn add mar-rt-10" @click.prevent="fetchSpvInboxImport" :title="$t('gestiune.fetchInvoice')">
              {{$t('gestiune.fetchInvoice')}}
            </button> -->
         </div>
      </div>
      <div class="card mar-to-15 tableInvoice">
          <div class="card-content">
            <div :class="(loading ? 'show-loader' : 'hide-loader')">
              <div class="el-loading-spinner">
                <svg viewBox="25 25 50 50" class="circular">
                  <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                </svg><!---->
              </div>
            </div>
            <div class="data-table">
                <el-table :data="tableData" :empty-text="$t('gestiune.noData')" style="width: 100%;">
                    <el-table-column prop="invoiceNumber" :label="$t('invoice.invoice')" width="100"></el-table-column>
                    <el-table-column prop="series" :label="$t('invoice.series')" width="80"></el-table-column>
                    <el-table-column prop="client" :label="$t('invoice.client')" width="190"></el-table-column>
                    <el-table-column prop="issueDate" :label="$t('invoice.issueDate')" :formatter="formatDate"></el-table-column>
                    <el-table-column prop="valueNoVAT" :label="$t('invoice.valueNoVAT')"></el-table-column>
                    <el-table-column prop="vatValue" :label="$t('invoice.vatValue')"></el-table-column>
                    <el-table-column prop="totalValue" :label="$t('invoice.totalValue')"></el-table-column>
                    <el-table-column :label="$t('invoice.spvStatus')" min-width="140">
                      <template slot-scope="scope">
                        <div class="spv-status-cell">
                          <span
                            class="spv-status-badge"
                            :class="scope.row.spvStatusClass"
                            :title="scope.row.spvStatusTitle"
                          >
                            {{ scope.row.spvStatusLabel }}
                          </span>
                          <span
                            v-if="scope.row.spvIdIncarcare"
                            class="spv-status-index-badge"
                            :title="$t('invoice.spvUploadIndex')"
                          >
                            Index: {{ scope.row.spvIdIncarcare }}
                          </span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="Nr. comandă / bon" min-width="150" align="left" class-name="order-info-column">
                      <template slot-scope="scope">
                        <div class="order-info-cell">
                          <button
                            type="button"
                            class="order-info-trigger"
                            :class="{
                              'order-info-trigger--active': scope.row.hasOrderInfo,
                              'order-info-trigger--loading': scope.row._orderInfoLoading
                            }"
                            title="Vezi date comandă"
                            @click.stop="openOrderInfo(scope.row)"
                          >
                            <i class="ti-info-alt"></i>
                          </button>
                          <span
                            v-if="scope.row.orderInfoDisplay"
                            class="order-info-number"
                            :title="scope.row.orderInfoDisplay"
                          >
                            {{ scope.row.orderInfoDisplay }}
                          </span>
                          <span v-else class="order-info-number order-info-number--empty">—</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('general.actions')" width="80" align="center" fixed="right" class-name="invoice-actions-column">
                      <template slot-scope="scope">
                        <div class="invoice-actions-cell">
                          <el-dropdown trigger="click" placement="bottom-end">
                          <!-- Trigger: sageata jos într-un chenar -->
                          <span class="arrow-box">
                            &#9662; <!-- sageata jos -->
                          </span>
                          <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                            <el-dropdown-item @click.native="editInvoice(scope.row.invoiceNumber, scope.row.series)">
                              {{$t('general.edit')}}
                            </el-dropdown-item>
                            <el-dropdown-item
                              @click.native="openOrderInfo(scope.row)"
                            >
                              Vezi date comandă
                            </el-dropdown-item>
                            <el-dropdown-item
                              :disabled="scope.row.hasParent"
                              @click.native="addStorno(scope.row.invoiceNumber, scope.row.series)"
                            >
                              {{$t('invoice.storno')}}
                            </el-dropdown-item>
                            <el-dropdown-item
                              :disabled="!canSendToSpv(scope.row)"
                              :class="{ disabled: !canSendToSpv(scope.row) }"
                              @click.native="sendToSPV(scope.row)"
                            >
                              {{$t('gestiune.sendToSPV')}}
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="downloadEfacturaXml(scope.row)">
                              {{$t('gestiune.downloadEfacturaXml')}}
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="viewSpvPdf(scope.row)">
                              {{$t('gestiune.viewSpvPdf')}}
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="verifySpvStatus(scope.row)">
                              {{$t('gestiune.checkSpvStatus')}}
                            </el-dropdown-item>
                            <el-dropdown-item
                              v-if="hasNexusLocation"
                              :disabled="!scope.row.orderNumber"
                              @click.native="fetchNexusInvoiceStatus(scope.row)"
                            >
                              {{$t('nexus.invoiceStatus')}}
                            </el-dropdown-item>
                            <el-dropdown-item
                              v-if="hasNexusLocation"
                              :disabled="!scope.row.orderNumber"
                              @click.native="fetchNexusInvoiceLogs(scope.row)"
                            >
                              {{$t('nexus.invoiceLog')}}
                            </el-dropdown-item>
                            <el-dropdown-item
                              v-if="hasNexusLocation"
                              :disabled="!scope.row.orderNumber"
                              @click.native="markNexusInvoice(scope.row)"
                            >
                              {{$t('nexus.invoiceSend')}}
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="downloadInvoice(scope.row)">
                              {{$t('invoice.download')}}
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="downloadExcel(scope.row)">
                              {{$t('gestiune.downloadExcel')}}
                            </el-dropdown-item>
                            <el-dropdown-item
                              :disabled="!canDeleteInvoice(scope.row, scope.$index)"
                              :class="{ disabled: !canDeleteInvoice(scope.row, scope.$index) }"
                              @click.native="handleDeleteInvoice(scope.row.id)"
                              style="color: red; font-weight: bold;"
                            >
                              {{$t('general.delete')}}
                            </el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                        </div>
                      </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="pageSize"
                  :current-page="currentPage"
                  @current-change="handlePageChange"
                  style="margin-top: 15px; text-align: right;"
                ></el-pagination>
            </div>
           </div>
      </div>
    </div>
</template>

<script>
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import swal from 'sweetalert2'

export default {
  components: {
    // GeneralTopBar
  },
  data () {
    return {
      loading: false,
      loadingTimeout: null,
      onSeriesInputTimeout: null,
      tableData: [],
      allLocations: [],
      totalItems: 0,
      currentPage: 1,
      pageSize: 20,
      filter: {
        series: ''
      },
      vatNumber: null,
      selectedLocation: null,
      spvStatusRefreshInProgress: false
    }
  },
  computed: {
    hasNexusLocation () {
      const defaultData = this.$session.get('defaultData') || {}
      return !!defaultData.has_nexus_location
    }
  },
  props: {
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  created () {
    this.companyID = this.$session.get('selectedCompany')

    this.$bus.$on('refresh', this.handleRefresh)
  },
  mounted () {
    this.$bus.$on('refresh', this.handleRefresh)
  },
  beforeDestroy () {
    this.$bus.$off('refresh', this.handleRefresh)
  },
  methods: {
    handleRefresh () {
      this.getInvoices(this.filter.series || '', 'invoice', { locations: this.allLocations })
    },
    onSearch () {
      // Validare locație
      if (!this.selectedLocation || (Array.isArray(this.selectedLocation) && this.selectedLocation.length === 0)) {
        swal({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați cel puțin o locație',
          confirmButtonText: 'OK'
        })

        this.tableData = []
        this.totalItems = 0

        return
      }

      // Dacă toate sunt OK, faci fetch
      const locations = Array.isArray(this.selectedLocation) ? this.selectedLocation : [this.selectedLocation]
      this.getInvoices(this.filter.series || '', 'invoice', { locations })
    },
    handlePageChange (page) {
      this.currentPage = page
      this.getInvoices(this.filter.series || '', 'invoice', this.selectedLocation, this.currentPage, this.pageSize)
    },
    onSeriesInput (value) {
      this.filter.series = value
    },
    addInvoice () {
      this.$router.push('/invoice-tabs/invoice/add')
    },
    async promptSpvInboxDays (titleKey) {
      if (!this.companyID) {
        swal({
          type: 'error',
          title: this.$t('general.error'),
          text: 'Lipsește compania selectată.',
          confirmButtonText: 'OK'
        })
        return null
      }

      if (!this.selectedLocation || !this.selectedLocation.inv_fiscal_code) {
        swal({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați o locație cu CIF fiscal pentru preluarea mesajelor SPV.',
          confirmButtonText: 'OK'
        })
        return null
      }

      const daysResult = await this.openSpvSwal({
        title: ' ',
        html: `
          <div class="spv-prompt-card">
            <div class="spv-prompt-header">
              <span class="spv-prompt-logo">SPV</span>
              <div>
                <p class="spv-prompt-title">${this.escapeHtml(this.$t(titleKey))}</p>
                <p class="spv-prompt-subtitle">${this.escapeHtml(this.$t('gestiune.fetchInvoiceDaysLabel'))}</p>
              </div>
            </div>
            <select id="spv-inbox-days" class="spv-prompt-select form-control">
              <option value="1">1 zi</option>
              <option value="7" selected>7 zile</option>
              <option value="15">15 zile</option>
              <option value="30">30 zile</option>
            </select>
          </div>
        `,
        type: 'question',
        customClass: 'spv-swal spv-swal--prompt',
        showCancelButton: true,
        confirmButtonText: this.$t(titleKey),
        cancelButtonText: this.$t('general.cancel') || 'Anulează',
        focusConfirm: false,
        preConfirm: () => {
          const select = document.getElementById('spv-inbox-days')
          const value = select ? Number(select.value) : 0

          if (![1, 7, 15, 30].includes(value)) {
            return Promise.reject(this.$t('gestiune.fetchInvoiceDaysInvalid'))
          }

          return Promise.resolve(value)
        }
      })

      if (daysResult === undefined || daysResult === null) return null

      const hasSwalShape = typeof daysResult === 'object' && (
        Object.prototype.hasOwnProperty.call(daysResult, 'value') ||
        Object.prototype.hasOwnProperty.call(daysResult, 'dismiss')
      )

      if (hasSwalShape && daysResult.dismiss) return null

      const zile = hasSwalShape ? daysResult.value : daysResult
      if (!zile) return null

      return Number(zile)
    },
    openSpvSwal (options = {}) {
      const defaults = {
        confirmButtonText: 'OK',
        customClass: 'spv-swal',
        confirmButtonClass: 'spv-swal-btn spv-swal-btn--confirm',
        cancelButtonClass: 'spv-swal-btn spv-swal-btn--cancel',
        buttonsStyling: false
      }

      return swal({ ...defaults, ...options })
    },
    showSpvSimpleAlert (type, title, text) {
      return this.openSpvSwal({
        type,
        title,
        text,
        customClass: `spv-swal spv-swal--${type || 'info'}`
      })
    },
    buildSpvInboxQueryParams (zile) {
      return new URLSearchParams({
        externalCompanyId: this.companyID,
        zile: String(zile),
        cif: this.normalizeCif(this.selectedLocation.inv_fiscal_code),
        mode: this.getSpvMode()
      })
    },
    formatSpvInboxDate (value) {
      const raw = String(value || '')
      if (raw.length < 12) return raw

      const year = raw.slice(0, 4)
      const month = raw.slice(4, 6)
      const day = raw.slice(6, 8)
      const hour = raw.slice(8, 10)
      const minute = raw.slice(10, 12)

      return `${day}.${month}.${year}, ${hour}:${minute}`
    },
    extractSpvInboxMessages (data) {
      if (!data || typeof data !== 'object') return []
      if (Array.isArray(data)) return data
      if (Array.isArray(data.mesaje)) return data.mesaje
      if (Array.isArray(data.messages)) return data.messages
      if (Array.isArray(data.items)) return data.items
      if (Array.isArray(data.data)) return data.data
      return []
    },
    getSpvInboxTipClass (tip) {
      const value = String(tip || '').toUpperCase()
      if (value.includes('EROARE') || value.includes('ERORI')) return 'spv-inbox-tip--error'
      if (value.includes('PRIMIT') || value === 'P') return 'spv-inbox-tip--received'
      if (value.includes('TRIMIS') || value === 'T') return 'spv-inbox-tip--sent'
      return 'spv-inbox-tip--default'
    },
    buildSpvInboxMessageRowHtml (message) {
      const tip = message.tip || message.type || '-'
      const tipClass = this.getSpvInboxTipClass(tip)
      const messageId = message.id || message.anafMessageId || message.messageId || ''

      return `
        <tr>
          <td>${this.escapeHtml(this.formatSpvInboxDate(message.data_creare || message.data || message.date))}</td>
          <td><span class="spv-inbox-tip ${tipClass}">${this.escapeHtml(String(tip))}</span></td>
          <td>${this.escapeHtml(String(message.id || '-'))}</td>
          <td>${this.escapeHtml(String(message.id_solicitare || message.id_incarcare || '-'))}</td>
          <td class="spv-inbox-details">${this.escapeHtml(String(message.detalii || message.details || '-'))}</td>
          <td class="spv-inbox-actions">
            <button
              type="button"
              class="spv-inbox-download-btn"
              data-message-id="${this.escapeHtml(String(messageId))}"
              ${messageId ? '' : 'disabled'}
            >
              ${this.escapeHtml(this.$t('gestiune.downloadSpvMessage'))}
            </button>
          </td>
        </tr>
      `
    },
    buildSpvInboxMessagesHtml (data, zile) {
      const messages = this.extractSpvInboxMessages(data)
      const total = data.total != null ? data.total : messages.length
      const title = data.titlu || data.title || 'Lista mesaje'
      const infoMessage = data.eroare || data.message || null

      if (!messages.length) {
        return `
          <div class="spv-inbox-card">
            <div class="spv-inbox-header spv-inbox-header--empty">
              <span class="spv-inbox-logo">SPV</span>
              <div>
                <p class="spv-inbox-title">${this.escapeHtml(title)}</p>
                <div class="spv-inbox-chips">
                  <span class="spv-inbox-chip">Total: 0</span>
                  <span class="spv-inbox-chip spv-inbox-chip--muted">${zile} zile</span>
                </div>
              </div>
            </div>
            ${infoMessage ? `<div class="spv-inbox-empty-msg">${this.escapeHtml(infoMessage)}</div>` : ''}
          </div>
        `
      }

      const rows = messages.map(message => this.buildSpvInboxMessageRowHtml(message)).join('')

      return `
        <div class="spv-inbox-card">
          <div class="spv-inbox-header">
            <span class="spv-inbox-logo">SPV</span>
            <div>
              <p class="spv-inbox-title">${this.escapeHtml(title)}</p>
              <div class="spv-inbox-chips">
                <span class="spv-inbox-chip spv-inbox-chip--primary">${total} mesaje</span>
                <span class="spv-inbox-chip spv-inbox-chip--muted">Ultimele ${zile} zile</span>
              </div>
            </div>
          </div>
          <div class="spv-inbox-table-wrap">
            <table class="spv-inbox-table">
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Tip</th>
                  <th>ID mesaj</th>
                  <th>ID încărcare</th>
                  <th>Detalii</th>
                  <th>Acțiuni</th>
                </tr>
              </thead>
              <tbody>${rows}</tbody>
            </table>
          </div>
        </div>
      `
    },
    buildSpvInboxDownloadBaseUrl (messageId) {
      return `${this.getEfacturaBaseUrl()}/efactura/inbox/messages/${encodeURIComponent(messageId)}/download`
    },
    buildSpvInboxDownloadQueryParams (extra = {}) {
      const params = new URLSearchParams({
        externalCompanyId: this.companyID,
        cif: this.normalizeCif(this.selectedLocation.inv_fiscal_code),
        mode: this.getSpvMode()
      })

      Object.keys(extra).forEach(key => {
        params.set(key, extra[key])
      })

      return params
    },
    buildEfacturaPurchasePdfBaseUrl (invoiceId) {
      return `${this.getEfacturaBaseUrl()}/efactura/invoice/pdf/${encodeURIComponent(invoiceId)}`
    },
    buildEfacturaPurchasePdfQueryParams (extra = {}) {
      const params = new URLSearchParams({
        externalCompanyId: this.companyID,
        cif: this.normalizeCif(this.selectedLocation.inv_fiscal_code),
        mode: this.getSpvMode()
      })

      Object.keys(extra).forEach(key => {
        params.set(key, extra[key])
      })

      return params
    },
    formatEfacturaErrorMessage (msg) {
      const text = String(msg || '').trim()
      if (!text) return 'A apărut o eroare.'

      if (/no anaf access token/i.test(text)) {
        return 'Nu există token SPV activ pentru compania/CIF-ul selectat. Activați tokenul din Setări Gestiune > Operațiuni generale.'
      }

      return text
    },
    async handleSpvInboxDownloadResponse (url, errorTitle) {
      const response = await fetch(url, { method: 'GET' })
      const dataText = await response.text()

      let parsed = null
      try {
        parsed = JSON.parse(dataText)
      } catch (e) {
        parsed = null
      }

      if (!response.ok || (parsed && parsed.error)) {
        let msg = 'A apărut o eroare.'

        if (parsed && parsed.anaf_error) {
          try {
            const anafObj = JSON.parse(parsed.anaf_error)
            if (anafObj && anafObj.eroare) msg = anafObj.eroare
          } catch (e) {}
        } else if (parsed && parsed.error) {
          msg = parsed.error
        } else if (parsed && parsed.eroare) {
          msg = parsed.eroare
        } else if (parsed && parsed.message) {
          msg = parsed.message
        }

        msg = this.formatEfacturaErrorMessage(msg)

        swal({
          title: errorTitle || this.$t('general.error'),
          text: msg,
          type: 'error',
          showConfirmButton: true,
          confirmButtonText: 'OK',
          confirmButtonClass: 'spv-swal-btn spv-swal-btn--confirm',
          customClass: 'spv-swal spv-swal--error spv-swal--toast'
        })

        return null
      }

      return parsed
    },
    bindSpvInboxDownloadButtons () {
      const buttons = document.querySelectorAll('.spv-inbox-download-btn')

      buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault()
          const messageId = button.getAttribute('data-message-id')
          if (messageId) this.downloadSpvInboxMessage(messageId)
        })
      })
    },
    async downloadSpvInboxMessage (messageId) {
      if (!messageId) return

      if (!this.companyID || !this.selectedLocation || !this.selectedLocation.inv_fiscal_code) {
        this.showSpvSimpleAlert('warning', this.$t('general.required'), 'Selectați o locație cu CIF fiscal pentru descărcare.')
        return
      }

      try {
        const base = this.buildSpvInboxDownloadBaseUrl(messageId)
        const checkUrl = `${base}?${this.buildSpvInboxDownloadQueryParams({ check: '1' }).toString()}`
        const result = await this.handleSpvInboxDownloadResponse(checkUrl, 'Eroare descărcare')

        if (!result) return

        if (result.status === true) {
          const downloadUrl = `${base}?${this.buildSpvInboxDownloadQueryParams({ download: '1' }).toString()}`
          window.open(downloadUrl, '_blank')
          return
        }

        this.showSpvSimpleAlert(
          'error',
          this.$t('general.error'),
          result.message || result.eroare || 'Descărcarea nu este disponibilă.'
        )
      } catch (error) {
        console.error('Error downloading SPV inbox message:', error)
        this.showSpvSimpleAlert(
          'error',
          this.$t('general.error'),
          error.message || 'Eroare neașteptată la descărcare.'
        )
      }
    },
    async fetchSpvInboxMessages () {
      const zile = await this.promptSpvInboxDays('gestiune.fetchSpvMessages')
      if (!zile) return

      const url = `${this.getEfacturaBaseUrl()}/efactura/inbox/messages?${this.buildSpvInboxQueryParams(zile).toString()}`

      try {
        this.loading = true

        const response = await fetch(url)
        const data = await this.parseEfacturaResponseBody(response)
        const messages = this.extractSpvInboxMessages(data)
        const infoMessage = data.eroare || data.message || null

        if (!response.ok) {
          throw new Error(infoMessage || data.error || 'Preluarea mesajelor SPV a eșuat.')
        }

        this.openSpvSwal({
          title: ' ',
          html: this.buildSpvInboxMessagesHtml(data, zile),
          customClass: `spv-swal spv-swal--inbox${messages.length ? '' : ' spv-swal--inbox-empty'}`,
          width: messages.length > 0 ? 1040 : 520,
          onOpen: () => {
            this.bindSpvInboxDownloadButtons()
          }
        })
      } catch (error) {
        console.error('Error fetching SPV inbox messages:', error)
        this.showSpvSimpleAlert(
          'error',
          this.$t('general.error'),
          error.message || 'Eroare la preluarea mesajelor SPV.'
        )
      } finally {
        this.loading = false
      }
    },
    async fetchSpvInboxImport () {
      const zile = await this.promptSpvInboxDays('gestiune.fetchInvoice')
      if (!zile) return

      const url = `${this.getEfacturaBaseUrl()}/efactura/inbox/import?${this.buildSpvInboxQueryParams(zile).toString()}`

      try {
        this.loading = true

        const response = await fetch(url)
        const data = await this.parseEfacturaResponseBody(response)

        if (!response.ok) {
          throw new Error(data.eroare || data.message || data.error || 'Importul facturilor SPV a eșuat.')
        }

        const importedCount = (data.imported && data.imported.length) || 0
        const infoMessage = data.eroare || data.message || null

        swal({
          type: importedCount > 0 ? 'success' : 'info',
          title: data.titlu || data.title || this.$t('gestiune.fetchInvoice'),
          html: `
            <div style="text-align:left;">
              ${infoMessage ? `<p>${this.escapeHtml(infoMessage)}</p>` : ''}
              <p><b>Importate:</b> ${importedCount}</p>
              <p><b>Sărite:</b> ${(data.skipped && data.skipped.length) || 0}</p>
              <p><b>Zile:</b> ${zile}</p>
            </div>
          `,
          confirmButtonText: 'OK'
        })
      } catch (error) {
        console.error('Error importing SPV inbox messages:', error)
        swal({
          type: 'error',
          title: this.$t('general.error'),
          text: error.message || 'Eroare la importul facturilor SPV.',
          confirmButtonText: 'OK'
        })
      } finally {
        this.loading = false
      }
    },
    addStorno (invoiceNumber, series) {
      if (!invoiceNumber || !series) {
        console.error('Missing invoice number or series')
        return
      }

      const stornoId = `${series}-${invoiceNumber}`
      this.$router.push(`/invoice-tabs/invoice/storno/${stornoId}`)
    },
    editInvoice (invoiceNumber, series) {
      if (!invoiceNumber || !series) {
        console.error('Missing invoice number or series')
        return
      }

      const stornoId = `${series}-${invoiceNumber}`
      this.$router.push(`/invoice-tabs/invoice/edit/${stornoId}`)
    },
    formatDate (row, column, cellValue) {
      if (!cellValue) return ''
      return new Date(cellValue).toLocaleDateString()
    },
    parseOrderInfoFromObservatiiText (text) {
      if (!text) return null

      const value = String(text).trim()
      if (!value) return null

      try {
        const parsed = JSON.parse(value)
        if (parsed && typeof parsed === 'object') {
          const hasOrderInfo = !!(
            parsed.orderDate ||
            parsed.orderNumber ||
            parsed.bonData ||
            parsed.bonNumber
          )

          if (hasOrderInfo) {
            return {
              orderDate: parsed.orderDate || '',
              orderNumber: parsed.orderNumber != null ? String(parsed.orderNumber) : '',
              bonData: parsed.bonData || '',
              bonNumber: parsed.bonNumber || ''
            }
          }
        }
      } catch (e) {}

      const orderMatch = value.match(/Comand[aă]\s+nr\.\s*(\d+)\s+din\s+([^\n.]+)/i)
      const bonMatch = value.match(/Bon fiscal\s+NR\s*([^/]+)\s*\/\s*Z\s*(\S+)\s+din\s+([^\n.]+)/i)

      if (!orderMatch && !bonMatch) return null

      return {
        orderDate: orderMatch ? orderMatch[2].trim() : '',
        orderNumber: orderMatch ? String(orderMatch[1]) : '',
        bonData: bonMatch ? bonMatch[3].trim() : '',
        bonNumber: bonMatch
          ? `NR: ${bonMatch[1].trim()} Z: ${bonMatch[2].trim()}`
          : ''
      }
    },
    parseOrderInfoFromNotaInterna (notaInterna) {
      return this.parseOrderInfoFromObservatiiText(notaInterna)
    },
    formatPaymentTypeLabel (paymentType) {
      if (!paymentType) return ''

      const key = `paymentTypes.${paymentType}`
      const translated = this.$t(key)
      return translated !== key ? translated : paymentType
    },
    extractPaymentTypeFromInvoice (invoice, extraFieldsMap = {}) {
      if (!invoice) {
        return extraFieldsMap.paymentType || extraFieldsMap.payment_type || ''
      }

      return (
        invoice.paymentType ||
        invoice.payment_type ||
        extraFieldsMap.paymentType ||
        extraFieldsMap.payment_type ||
        ''
      )
    },
    extractOrderInfoFromInvoice (invoice) {
      if (!invoice) {
        return {
          orderDate: '',
          orderNumber: '',
          bonData: '',
          bonNumber: '',
          paymentType: ''
        }
      }

      let extraFieldsMap = {}
      if (Array.isArray(invoice.extraFields)) {
        extraFieldsMap = invoice.extraFields.reduce((acc, field) => {
          acc[field.key] = field.value
          return acc
        }, {})
      }

      let result = null

      const fromBonNota = this.parseOrderInfoFromObservatiiText(invoice.bonNota)
      if (fromBonNota) {
        result = fromBonNota
      } else if (invoice.orderDate || invoice.orderNumber || invoice.bonData || invoice.bonNumber) {
        result = {
          orderDate: invoice.orderDate || '',
          orderNumber: invoice.orderNumber != null ? String(invoice.orderNumber) : '',
          bonData: invoice.bonData || '',
          bonNumber: invoice.bonNumber || ''
        }
      } else {
        const fromObservatii = this.parseOrderInfoFromObservatiiText(
          extraFieldsMap.observatiiFactura || extraFieldsMap.observatiiComanda
        )
        if (fromObservatii) {
          result = fromObservatii
        } else {
          const fromNotaInterna = this.parseOrderInfoFromObservatiiText(extraFieldsMap.notaInterna)
          if (fromNotaInterna) {
            result = fromNotaInterna
          } else {
            result = {
              orderDate: invoice.orderDate || extraFieldsMap.orderDate || '',
              orderNumber: invoice.orderNumber != null
                ? String(invoice.orderNumber)
                : (extraFieldsMap.orderNumber || ''),
              bonData: invoice.bonData || extraFieldsMap.bonData || '',
              bonNumber: invoice.bonNumber || extraFieldsMap.bonNumber || ''
            }
          }
        }
      }

      result.paymentType = this.extractPaymentTypeFromInvoice(invoice, extraFieldsMap)
      return result
    },
    applyOrderInfoToRow (row, invoice) {
      const orderInfo = this.extractOrderInfoFromInvoice(invoice)

      row.orderDate = orderInfo.orderDate
      row.orderNumber = orderInfo.orderNumber
      row.bonData = orderInfo.bonData
      row.bonNumber = orderInfo.bonNumber
      row.paymentType = orderInfo.paymentType
      row.orderInfoDisplay = orderInfo.orderNumber || orderInfo.bonNumber || ''
      row.hasOrderInfo = !!(
        orderInfo.orderDate ||
        orderInfo.orderNumber ||
        orderInfo.bonData ||
        orderInfo.bonNumber ||
        orderInfo.paymentType
      )

      return row
    },
    async ensureOrderInfo (row) {
      if (!row || row._orderInfoLoading) return row
      if (row.hasOrderInfo && row.paymentType) return row

      row._orderInfoLoading = true

      try {
        const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/getDocument/?tip=invoice&series=${encodeURIComponent(row.series)}&number=${encodeURIComponent(row.invoiceNumber)}&externalCompanyId=${this.companyID}`
        const response = await fetch(url)

        if (!response.ok) return row

        const result = await response.json()
        const data = (result.documents && result.documents.length)
          ? result.documents[0]
          : (result.document || result)

        if (data && typeof data === 'object') {
          this.applyOrderInfoToRow(row, data)
          row.rawInvoice = { ...(row.rawInvoice || {}), ...data }
        }
      } catch (error) {
        console.error('Error loading invoice order info:', error)
      } finally {
        row._orderInfoLoading = false
      }

      return row
    },
    buildOrderInfoHtml (row) {
      const rows = [
        row.orderDate ? this.buildEfacturaDetailRow('Data comandă', row.orderDate) : '',
        row.orderNumber ? this.buildEfacturaDetailRow('Nr. comandă', `#${row.orderNumber}`) : '',
        row.bonData ? this.buildEfacturaDetailRow('Data bon', row.bonData) : '',
        row.bonNumber ? this.buildEfacturaDetailRow('Bon fiscal', row.bonNumber) : '',
        row.paymentType
          ? this.buildEfacturaDetailRow('Plată', `${this.formatPaymentTypeLabel(row.paymentType)} (${row.paymentType})`)
          : ''
      ].filter(Boolean).join('')

      return `
        <div class="invoice-order-info-card">
          <div class="invoice-order-info-card-header">
            <span class="invoice-order-info-card-icon"><i class="ti-receipt"></i></span>
            <div>
              <p class="invoice-order-info-card-title">Informații comandă</p>
              <p class="invoice-order-info-card-subtitle">Factură ${this.escapeHtml(`${row.series}-${row.invoiceNumber}`)}</p>
            </div>
          </div>
          <div class="invoice-order-info-card-body">${rows}</div>
        </div>
      `
    },
    showOrderInfo (row) {
      if (!row || !row.hasOrderInfo) return

      this.openSpvSwal({
        title: ' ',
        html: this.buildOrderInfoHtml(row),
        customClass: 'spv-swal spv-swal--order-info',
        width: 460,
        confirmButtonText: 'Închide'
      })
    },
    async openOrderInfo (row) {
      if (!row) return

      await this.ensureOrderInfo(row)

      if (!row.hasOrderInfo) {
        this.showSpvSimpleAlert(
          'info',
          'Date comandă',
          'Această factură nu are date de comandă sau bon fiscal asociate.'
        )
        return
      }

      this.showOrderInfo(row)
    },
    normalizeSpvStatusKey (status) {
      const value = String(status || '').toLowerCase().trim()

      if (['sent', 'trimis', 'ok', 'success', 'processed', 'finalizat'].includes(value)) {
        return 'sent'
      }
      if (['error', 'eroare', 'failed', 'nok', 'respins'].includes(value)) {
        return 'error'
      }
      if (['pending', 'processing', 'in_procesare', 'in procesare', 'in prelucrare', 'waiting'].includes(value)) {
        return 'pending'
      }

      return 'not_sent'
    },
    resolveSpvStatusFromInvoice (invoice) {
      if (!invoice) return 'not_sent'

      if (invoice.spvStatus) {
        return this.normalizeSpvStatusKey(invoice.spvStatus)
      }

      const spv = invoice.spv || invoice.efactura
      if (spv && typeof spv === 'object') {
        if (spv.error || spv.anafError) return 'error'
        if (spv.status) return this.normalizeSpvStatusKey(spv.status)
        if (spv.id_incarcare || spv.idIncarcare || spv.index_incarcare) {
          return (spv.id_descarcare || spv.spvMessageId || spv.messageId) ? 'sent' : 'pending'
        }
      }

      if (typeof spv === 'string') {
        return this.normalizeSpvStatusKey(spv)
      }

      if (invoice.spv_status) return this.normalizeSpvStatusKey(invoice.spv_status)
      if (invoice.efacturaStatus) return this.normalizeSpvStatusKey(invoice.efacturaStatus)
      if (invoice.spvIndex || invoice.id_incarcare || invoice.idIncarcare) {
        return this.extractSpvMessageIdFromInvoice(invoice) ? 'sent' : 'pending'
      }

      if (Array.isArray(invoice.extraFields)) {
        const field = invoice.extraFields.find(item =>
          ['spv_status', 'efactura_status', 'spvStatus'].includes(item.key)
        )
        if (field && field.value) {
          return this.normalizeSpvStatusKey(field.value)
        }
      }

      return 'not_sent'
    },
    getSpvStatusMeta (status) {
      const key = this.normalizeSpvStatusKey(status)

      const map = {
        not_sent: { labelKey: 'invoice.spvStatusNotSent', className: 'spv-status--none' },
        sent: { labelKey: 'invoice.spvStatusSent', className: 'spv-status--sent' },
        error: { labelKey: 'invoice.spvStatusError', className: 'spv-status--error' },
        pending: { labelKey: 'invoice.spvStatusPending', className: 'spv-status--pending' }
      }

      return map[key] || map.not_sent
    },
    extractSpvIdIncarcareFromInvoice (invoice) {
      if (!invoice) return null

      const spv = invoice.spv || {}
      return (
        invoice.spvIndex ||
        invoice.id_incarcare ||
        invoice.idIncarcare ||
        spv.id_incarcare ||
        spv.idIncarcare ||
        spv.index_incarcare ||
        null
      )
    },
    extractSpvMessageIdFromInvoice (invoice) {
      if (!invoice) return null

      return invoice.spvMessageId || invoice.id_descarcare || invoice.idDescarcare || null
    },
    buildSpvStatusTitle (invoice) {
      const idIncarcare = this.extractSpvIdIncarcareFromInvoice(invoice)
      const messageId = this.extractSpvMessageIdFromInvoice(invoice)
      const parts = []

      if (idIncarcare) parts.push(`ID încărcare: ${idIncarcare}`)
      if (messageId) parts.push(`ID mesaj: ${messageId}`)

      return parts.join(' · ')
    },
    applySpvStatusToRow (row, invoice) {
      const status = this.resolveSpvStatusFromInvoice(invoice)
      const meta = this.getSpvStatusMeta(status)
      const idIncarcare = this.extractSpvIdIncarcareFromInvoice(invoice)

      row.spvStatus = status
      row.spvStatusLabel = this.$t(meta.labelKey)
      row.spvStatusClass = meta.className
      row.spvIdIncarcare = idIncarcare
      row.spvMessageId = this.extractSpvMessageIdFromInvoice(invoice)
      row.spvStatusTitle = this.buildSpvStatusTitle(invoice)

      return row
    },
    canSendToSpv (row) {
      if (!row || !row.rawInvoice) return false

      const status = this.normalizeSpvStatusKey(
        row.spvStatus || row.rawInvoice.spvStatus || this.resolveSpvStatusFromInvoice(row.rawInvoice)
      )

      return !['sent', 'pending'].includes(status)
    },
    canDeleteInvoice (row, index) {
      if (index !== 0 || !row) return false

      const status = this.normalizeSpvStatusKey(
        row.spvStatus || row.rawInvoice.spvStatus || this.resolveSpvStatusFromInvoice(row.rawInvoice)
      )

      return !['sent', 'pending'].includes(status)
    },
    getPendingSpvRows (rows = this.tableData) {
      return (rows || []).filter((row) => {
        const invoice = row.rawInvoice
        if (!invoice) return false

        const idIncarcare = this.extractSpvIdIncarcareFromInvoice(invoice) || row.spvIdIncarcare
        if (!idIncarcare) return false

        const status = this.normalizeSpvStatusKey(invoice.spvStatus || row.spvStatus || 'not_sent')
        return status === 'pending'
      })
    },
    getSpvCifForBatch (rows = []) {
      if (this.selectedLocation && this.selectedLocation.inv_fiscal_code) {
        return this.normalizeCif(this.selectedLocation.inv_fiscal_code)
      }

      for (const row of rows) {
        const cif = this.getSpvCif(row.rawInvoice)
        if (cif) return cif
      }

      return null
    },
    normalizeBatchStatusResult (item, cif) {
      const idIncarcare = item && (item.id || item.idIncarcare)
        ? String(item.id || item.idIncarcare)
        : null

      if (!item || item.success === false) {
        const errorPayload = item && item.error
        const anafError = typeof errorPayload === 'string'
          ? errorPayload
          : (errorPayload && (errorPayload.message || errorPayload.error || errorPayload.eroare)) ||
            'Nu s-a putut verifica statusul ANAF.'

        return {
          success: false,
          pending: false,
          idIncarcare,
          anafError,
          cif,
          mode: this.getSpvMode()
        }
      }

      const payload = item.data != null ? item.data : item
      const normalized = this.normalizeEfacturaApiResponse(payload, cif)
      normalized.idIncarcare = normalized.idIncarcare || idIncarcare

      return normalized
    },
    async checkEfacturaStatusesBatch (ids, cif) {
      const uniqueIds = [...new Set((ids || []).map(id => String(id)).filter(Boolean))]
      if (!uniqueIds.length) return { results: [] }

      const params = new URLSearchParams({
        externalCompanyId: this.companyID,
        cif: this.normalizeCif(cif),
        mode: this.getSpvMode()
      })

      const response = await fetch(
        `${this.getEfacturaBaseUrl()}/efactura/statuses?${params.toString()}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ids: uniqueIds })
        }
      )

      const data = await this.parseEfacturaResponseBody(response)

      if (!response.ok) {
        throw new Error(this.parseAnafError(data, 'Nu s-a putut verifica statusul facturilor în SPV.'))
      }

      if (Array.isArray(data)) {
        return { results: data }
      }

      if (Array.isArray(data.results)) {
        return data
      }

      return { results: [] }
    },
    resolveSpvStatusFromEfacturaResult (result) {
      if (!result) return 'error'
      if (result.pending || this.isEfacturaStatusPending(result)) return 'pending'
      if (result.success) return 'sent'
      return 'error'
    },
    async refreshInvoicesSpvStatuses (rows = this.tableData, options = {}) {
      const { persist = true } = options
      const pendingRows = this.getPendingSpvRows(rows)

      if (!pendingRows.length || !this.companyID || this.spvStatusRefreshInProgress) {
        return
      }

      const cif = this.getSpvCifForBatch(pendingRows)
      if (!cif) return

      const idToRow = new Map()
      const ids = pendingRows.map((row) => {
        const id = String(this.extractSpvIdIncarcareFromInvoice(row.rawInvoice) || row.spvIdIncarcare)
        idToRow.set(id, row)
        return id
      })

      this.spvStatusRefreshInProgress = true

      try {
        const batch = await this.checkEfacturaStatusesBatch(ids, cif)

        for (const item of (batch.results || [])) {
          const id = item && (item.id || item.idIncarcare)
          const row = idToRow.get(String(id))
          if (!row) continue

          const normalized = this.normalizeBatchStatusResult(item, cif)
          const spvStatus = this.resolveSpvStatusFromEfacturaResult(normalized)
          const spvMessageId = normalized.spvMessageId || normalized.idDescarcare || null

          this.updateRowSpvStatus(
            row.id,
            spvStatus,
            normalized.idIncarcare || id,
            spvMessageId
          )

          if (persist) {
            try {
              await this.persistInvoiceSpvStatus(row, normalized)
            } catch (saveError) {
              console.error('Error persisting batch SPV status:', saveError)
            }
          }
        }
      } catch (error) {
        console.error('Error refreshing SPV statuses:', error)
      } finally {
        this.spvStatusRefreshInProgress = false
      }
    },
    updateRowSpvStatus (rowId, status, idIncarcare = null, spvMessageId = null) {
      const row = this.tableData.find(item => item.id === rowId)
      if (!row) return

      const meta = this.getSpvStatusMeta(status)

      row.spvStatus = this.normalizeSpvStatusKey(status)
      row.spvStatusLabel = this.$t(meta.labelKey)
      row.spvStatusClass = meta.className

      if (idIncarcare) {
        row.spvIdIncarcare = idIncarcare
      }

      if (spvMessageId) {
        row.spvMessageId = spvMessageId
      }

      if (row.rawInvoice) {
        row.rawInvoice.spvStatus = row.spvStatus
        if (idIncarcare) row.rawInvoice.spvIndex = String(idIncarcare)
        if (spvMessageId) row.rawInvoice.spvMessageId = String(spvMessageId)
      }

      row.spvStatusTitle = this.buildSpvStatusTitle(row.rawInvoice || {
        spvIndex: idIncarcare,
        spvMessageId
      })
    },
    mapEfacturaResultToSpvDocumentFields (result) {
      let spvStatus = 'error'

      if (result && (result.pending || this.isEfacturaStatusPending(result))) {
        spvStatus = 'pending'
      } else if (result && result.success) {
        spvStatus = 'sent'
      }

      const spvIndex = result && (result.idIncarcare || result.spvIndex)
        ? String(result.idIncarcare || result.spvIndex)
        : null
      const spvMessageId = result && (result.spvMessageId || result.idDescarcare)
        ? String(result.spvMessageId || result.idDescarcare)
        : null

      return {
        spvStatus,
        spvIndex,
        spvMessageId
      }
    },
    async saveInvoiceSpvDocument (invoice, spvFields) {
      const location = this.selectedLocation || {}
      const payload = {
        ...invoice,
        ...spvFields,
        tip: invoice.tip || 'invoice',
        externalCompanyId: invoice.externalCompanyId || this.companyID,
        externalLocationId: invoice.externalLocationId || (location && location.true_id),
        vatNumber: invoice.vatNumber || (location && location.inv_fiscal_code),
        number: invoice.number || invoice.invoiceNumber
      }

      const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/document`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })

      const data = await response.json().catch(() => ({}))

      if (!response.ok) {
        throw new Error(data.error || data.message || 'Nu s-a putut salva statusul SPV pe document.')
      }

      return data
    },
    async persistInvoiceSpvStatus (row, result) {
      if (!row || !row.rawInvoice) return null

      const spvFields = this.mapEfacturaResultToSpvDocumentFields(result)
      const savedDocument = await this.saveInvoiceSpvDocument(row.rawInvoice, spvFields)

      row.rawInvoice = {
        ...row.rawInvoice,
        ...spvFields,
        ...(savedDocument && typeof savedDocument === 'object' ? savedDocument : {})
      }

      this.applySpvStatusToRow(row, row.rawInvoice)

      return row.rawInvoice
    },
    buildEfacturaQueryParams (cif, standard = 'UBL') {
      return new URLSearchParams({
        externalCompanyId: this.companyID,
        cif: this.normalizeCif(cif),
        mode: this.getSpvMode(),
        standard
      })
    },
    showSpvProgress (title, text) {
      this.openSpvSwal({
        title: ' ',
        html: `
          <div class="spv-progress">
            <div class="spv-progress-spinner"></div>
            ${title ? `<p class="spv-progress-title">${this.escapeHtml(title)}</p>` : ''}
            <p class="spv-progress-text">${this.escapeHtml(text)}</p>
          </div>
        `,
        customClass: 'spv-swal spv-swal--progress',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
    },
    async postEfacturaJson (path, cif, body) {
      const standard = body.standard || 'UBL'
      const params = this.buildEfacturaQueryParams(cif, standard)
      const response = await fetch(
        `${this.getEfacturaBaseUrl()}${path}?${params.toString()}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        }
      )
      const data = await this.parseEfacturaResponseBody(response)

      return { response, data }
    },
    async parseEfacturaResponseBody (response) {
      const text = await response.text()
      if (!text || !text.trim()) return {}

      try {
        const parsed = JSON.parse(text)
        if (typeof parsed === 'string' && parsed.trim().startsWith('<')) {
          return { anaf_response: parsed.trim() }
        }
        return parsed
      } catch (e) {
        if (text.trim().startsWith('<')) {
          return { anaf_response: text.trim() }
        }
        return { message: text.trim() }
      }
    },
    async generateEfacturaXml (invoice, cif) {
      const payload = this.prepareInvoiceForEfactura(invoice)
      const { response, data } = await this.postEfacturaJson('/efactura/xml/generate', cif, {
        invoice: payload,
        standard: 'UBL'
      })

      if (!response.ok || !data.xml) {
        throw new Error(this.parseAnafError(data, 'Generarea XML UBL a eșuat.'))
      }

      return data.xml
    },
    async sendEfacturaDocument ({ invoice, xml, cif }) {
      const payload = this.prepareInvoiceForEfactura(invoice)
      const { response, data } = await this.postEfacturaJson('/efactura/send', cif, {
        invoice: payload,
        xml,
        standard: 'UBL'
      })

      const result = this.normalizeEfacturaApiResponse(data, cif)

      if (!response.ok) {
        result.success = false
        if (!result.anafError) {
          result.anafError = this.parseAnafError(data, 'Trimiterea în SPV a eșuat.')
        }
      }

      return result
    },
    getEfacturaBaseUrl () {
      return `${process.env.API_BASE_URL_GESTIUNE.replace(/\/$/, '')}:4443`
    },
    getSpvMode () {
      const raw = String(process.env.EFACTURA_MODE || 'TEST')
        .trim()
        .replace(/^['"]+|['"]+$/g, '')
        .toUpperCase()

      return raw === 'PROD' ? 'PROD' : 'TEST'
    },
    normalizeCif (cif) {
      return String(cif || '').replace(/^ro/i, '').trim()
    },
    getSpvCif (invoice) {
      const fromLocation = this.selectedLocation && this.selectedLocation.inv_fiscal_code
      const fromInvoice = (invoice.company && invoice.company.vatNumber) || invoice.vatNumber
      return this.normalizeCif(fromLocation || fromInvoice)
    },
    prepareInvoiceForEfactura (invoice) {
      const payload = { ...invoice }

      if (!payload.externalCompanyId && this.companyID) {
        payload.externalCompanyId = this.companyID
      }

      if (!payload.externalLocationId && this.selectedLocation && this.selectedLocation.true_id) {
        payload.externalLocationId = this.selectedLocation.true_id
      }

      if (!payload.vatNumber && payload.company && payload.company.vatNumber) {
        payload.vatNumber = payload.company.vatNumber
      }

      return payload
    },
    escapeHtml (value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
    },
    getExecutionStatusLabel (status) {
      if (status === '0') return 'Succes'
      if (status === '1') return 'Eroare'
      return status || '-'
    },
    parseAnafError (parsed, fallback) {
      if (!parsed) return fallback

      const indexedXml = this.reconstructIndexedString(parsed)
      if (indexedXml) {
        const xmlError = this.parseAnafXmlResponse(indexedXml)
        if (xmlError && xmlError.errorMessage) {
          const hint = /drept in spv/i.test(xmlError.errorMessage)
            ? ` Verificați token-ul SPV (ANAF) în Setări Gestiune.`
            : ''
          return xmlError.errorMessage + hint
        }
      }

      if (parsed.anaf_error) {
        try {
          const anafObj = typeof parsed.anaf_error === 'string'
            ? JSON.parse(parsed.anaf_error)
            : parsed.anaf_error
          if (anafObj && anafObj.eroare) return anafObj.eroare
          if (anafObj && anafObj.message) return anafObj.message
        } catch (e) {
          return parsed.anaf_error
        }
      }

      if (typeof parsed === 'string' && parsed.trim().startsWith('<')) {
        const xmlError = this.parseAnafXmlResponse(parsed)
        if (xmlError && xmlError.errorMessage) return xmlError.errorMessage
      }

      return parsed.message || parsed.error || fallback
    },
    reconstructIndexedString (data) {
      if (!data || typeof data !== 'object') return null

      const numericKeys = Object.keys(data).filter(key => /^\d+$/.test(key))
      if (numericKeys.length === 0) return null

      return numericKeys
        .sort((a, b) => Number(a) - Number(b))
        .map(key => data[key])
        .join('')
    },
    parseAnafXmlResponse (xml) {
      if (!xml || typeof xml !== 'string') return null

      const errorMessages = []
      const errorRegex = /errorMessage="([^"]+)"/gi
      let errorMatch = errorRegex.exec(xml)
      while (errorMatch) {
        errorMessages.push(errorMatch[1])
        errorMatch = errorRegex.exec(xml)
      }

      const executionMatch = xml.match(/ExecutionStatus="(\d+)"/i)
      const dateMatch = xml.match(/dateResponse="([^"]+)"/i)
      const stareMatch = xml.match(/\bstare="([^"]+)"/i)
      const idDescarcareMatch = xml.match(/\bid_descarcare="(\d+)"/i)
      const idMatch =
        xml.match(/index_incarcare="(\d+)"/i) ||
        xml.match(/id_incarcare="(\d+)"/i)

      const executionStatus = executionMatch ? executionMatch[1] : null
      const stare = stareMatch ? stareMatch[1] : null
      const stareNorm = stare ? String(stare).toLowerCase().trim() : ''
      const isStareError = ['nok', 'eroare', 'error', 'respins'].includes(stareNorm)
      const isError =
        errorMessages.length > 0 ||
        isStareError ||
        (executionStatus !== null && executionStatus !== '0')

      return {
        executionStatus,
        dateResponse: dateMatch ? dateMatch[1] : null,
        errorMessage: errorMessages[0] || null,
        errorMessages,
        idIncarcare: idMatch ? idMatch[1] : null,
        idDescarcare: idDescarcareMatch ? idDescarcareMatch[1] : null,
        stare,
        isError
      }
    },
    extractXmlFromResponse (data) {
      if (!data) return null
      if (typeof data === 'string' && data.trim().startsWith('<')) return data

      const indexedXml = this.reconstructIndexedString(data)
      if (indexedXml) return indexedXml

      if (typeof data.xml === 'string') return data.xml
      if (typeof data.anaf_response === 'string') return data.anaf_response

      return null
    },
    normalizeEfacturaStare (stare) {
      return String(stare || '').toLowerCase().trim()
    },
    isEfacturaStatusPending (statusData) {
      if (!statusData) return false
      if (statusData.pending) return true

      const stare = this.normalizeEfacturaStare(statusData.stare || statusData.status)
      return ['in prelucrare', 'in procesare', 'processing', 'pending', 'waiting'].includes(stare)
    },
    normalizeEfacturaApiResponse (data, cif) {
      const xmlSource = this.extractXmlFromResponse(data)
      const xmlParsed = xmlSource ? this.parseAnafXmlResponse(xmlSource) : null
      const idIncarcare = this.extractIdIncarcare(data) || (xmlParsed && xmlParsed.idIncarcare)
      const anafErrors = (xmlParsed && xmlParsed.errorMessages) || []
      const anafError = anafErrors[0] || data.error || data.message || null
      const resolvedCif = data.cif || cif || null
      const stare = data.stare || data.status || (xmlParsed && xmlParsed.stare) || null
      const stareNorm = this.normalizeEfacturaStare(stare)
      const isPending = this.isEfacturaStatusPending({ stare })
      const isStareOk = ['ok', 'processed', 'finalizat', 'succes', 'success'].includes(stareNorm)
      const isStareError = ['nok', 'eroare', 'error', 'respins'].includes(stareNorm)

      let success = false
      let pending = false

      if (anafErrors.length || (xmlParsed && xmlParsed.isError) || isStareError) {
        success = false
      } else if (isStareOk || (xmlParsed && xmlParsed.idDescarcare)) {
        success = true
      } else if (isPending) {
        pending = true
        success = true
      } else if (idIncarcare || (xmlParsed && xmlParsed.executionStatus === '0')) {
        success = true
      } else if (!data.error && (idIncarcare || stare)) {
        success = !isStareError
      }

      const hint = anafError && /drept in spv/i.test(anafError)
        ? `Verificați token-ul SPV (ANAF) activ pentru CIF ${resolvedCif || ''} în Setări Gestiune.`.replace(/\s+/g, ' ').trim()
        : null

      return {
        success,
        pending,
        cif: resolvedCif,
        mode: this.getSpvMode(),
        standard: data.standard || 'UBL',
        b2c: data.b2c,
        idIncarcare,
        idDescarcare: data.id_descarcare || data.idDescarcare || (xmlParsed && xmlParsed.idDescarcare) || null,
        spvMessageId: data.spvMessageId || data.id_message || data.messageId || data.id_descarcare || data.idDescarcare || (xmlParsed && xmlParsed.idDescarcare) || null,
        executionStatus: xmlParsed && xmlParsed.executionStatus,
        dateResponse: xmlParsed && xmlParsed.dateResponse,
        stare,
        anafErrors,
        anafError,
        hint,
        message: data.message || null
      }
    },
    formatAnafDateResponse (value) {
      const raw = String(value || '')
      if (raw.length < 12) return raw

      const year = raw.slice(0, 4)
      const month = raw.slice(4, 6)
      const day = raw.slice(6, 8)
      const hour = raw.slice(8, 10)
      const minute = raw.slice(10, 12)

      return `${day}.${month}.${year}, ${hour}:${minute}`
    },
    buildEfacturaDetailRow (label, value) {
      if (value === null || value === undefined || value === '') return ''

      return `
        <div class="spv-result-row">
          <span class="spv-result-label">${this.escapeHtml(label)}</span>
          <span class="spv-result-value">${this.escapeHtml(value)}</span>
        </div>
      `
    },
    buildEfacturaDetailRowWithDownload (label, value, messageId) {
      if (value === null || value === undefined || value === '') return ''

      const downloadButton = messageId
        ? `<button type="button" class="spv-inbox-download-btn spv-result-download-btn" data-message-id="${this.escapeHtml(String(messageId))}">${this.escapeHtml(this.$t('gestiune.viewSpvMessage'))}</button>`
        : ''

      return `
        <div class="spv-result-row spv-result-row--with-action">
          <span class="spv-result-label">${this.escapeHtml(label)}</span>
          <span class="spv-result-value spv-result-value--with-action">
            <span>${this.escapeHtml(String(value))}</span>
            ${downloadButton}
          </span>
        </div>
      `
    },
    buildEfacturaResultHtml (result, invoiceLabel) {
      const isPending = this.isEfacturaStatusPending(result)
      const isSuccess = !!result.success && !isPending
      const badgeText = isPending
        ? 'În procesare ANAF'
        : (isSuccess ? 'Trimis cu succes în SPV' : 'Respins de ANAF')
      const statusLabel = result.executionStatus !== null && result.executionStatus !== undefined
        ? this.getExecutionStatusLabel(result.executionStatus)
        : null
      const formattedDate = result.dateResponse
        ? this.formatAnafDateResponse(result.dateResponse)
        : null
      const spvMessageId = result.spvMessageId || result.idDescarcare

      const details = [
        this.buildEfacturaDetailRow('Factură', invoiceLabel),
        this.buildEfacturaDetailRow('CIF', result.cif),
        this.buildEfacturaDetailRow('Mediu SPV', result.mode),
        this.buildEfacturaDetailRow('Standard', result.standard),
        this.buildEfacturaDetailRow('Tip', result.b2c ? 'B2C' : 'B2B'),
        this.buildEfacturaDetailRow('ID încărcare', result.idIncarcare),
        spvMessageId
          ? this.buildEfacturaDetailRowWithDownload('ID mesaj SPV', spvMessageId, spvMessageId)
          : this.buildEfacturaDetailRow('ID descărcare', result.idDescarcare),
        this.buildEfacturaDetailRow('Status ANAF', statusLabel),
        this.buildEfacturaDetailRow('Data răspuns', formattedDate),
        this.buildEfacturaDetailRow('Stare procesare', result.stare)
      ].filter(Boolean).join('')

      let messageBlock = ''

      if (result.anafErrors && result.anafErrors.length) {
        const items = result.anafErrors
          .map(err => `<li>${this.escapeHtml(err)}</li>`)
          .join('')

        messageBlock = `
          <div class="spv-result-message spv-result-message--error">
            <div class="spv-result-message-title">Mesaj ANAF</div>
            <ul class="spv-result-errors">${items}</ul>
          </div>
        `
      } else if (result.anafError && !isSuccess) {
        messageBlock = `
          <div class="spv-result-message spv-result-message--error">
            <div class="spv-result-message-title">Mesaj ANAF</div>
            <p>${this.escapeHtml(result.anafError)}</p>
          </div>
        `
      } else if (isPending) {
        messageBlock = `
          <div class="spv-result-message spv-result-message--pending">
            <div class="spv-result-message-title">Status ANAF</div>
            <p>Factura a fost încărcată, dar ANAF încă o procesează. Verificați statusul mai târziu folosind ID-ul de încărcare.</p>
          </div>
        `
      } else if (isSuccess && result.message) {
        messageBlock = `
          <div class="spv-result-message spv-result-message--success">
            <div class="spv-result-message-title">Confirmare</div>
            <p>${this.escapeHtml(result.message)}</p>
          </div>
        `
      }

      const hintBlock = result.hint
        ? `<div class="spv-result-hint">${this.escapeHtml(result.hint)}</div>`
        : ''

      const headerClass = isPending
        ? 'spv-result-header--pending'
        : (isSuccess ? 'spv-result-header--success' : 'spv-result-header--error')

      return `
        <div class="spv-result-card">
          <div class="spv-result-header ${headerClass}">
            <span class="spv-result-header-icon"></span>
            <div class="spv-result-header-body">
              <strong>${this.escapeHtml(badgeText)}</strong>
              <span>${this.escapeHtml(invoiceLabel || '')}</span>
            </div>
          </div>
          <div class="spv-result-details">${details}</div>
          ${messageBlock}
          ${hintBlock}
        </div>
      `
    },
    showEfacturaAlert (type, title, result, invoiceLabel) {
      this.openSpvSwal({
        title,
        html: this.buildEfacturaResultHtml(result, invoiceLabel),
        customClass: `spv-swal spv-swal--result spv-swal--${type || 'info'}`,
        width: 560,
        onOpen: () => {
          this.bindSpvInboxDownloadButtons()
        }
      })
    },
    mergeEfacturaResults (sendResult, statusResult) {
      const pending = this.isEfacturaStatusPending(statusResult)
      const statusFailed = statusResult.success === false && !pending

      return {
        ...sendResult,
        success: sendResult.success && !statusFailed,
        pending,
        mode: this.getSpvMode(),
        stare: statusResult.stare || sendResult.stare,
        idDescarcare: statusResult.idDescarcare || sendResult.idDescarcare,
        spvMessageId: statusResult.spvMessageId || sendResult.spvMessageId || statusResult.idDescarcare || sendResult.idDescarcare,
        executionStatus: statusResult.executionStatus || sendResult.executionStatus,
        dateResponse: statusResult.dateResponse || sendResult.dateResponse,
        anafErrors: (statusResult.anafErrors && statusResult.anafErrors.length)
          ? statusResult.anafErrors
          : (sendResult.anafErrors || []),
        anafError: statusResult.anafError || sendResult.anafError,
        hint: statusResult.hint || sendResult.hint,
        message: statusResult.message || sendResult.message
      }
    },
    extractIdIncarcare (data) {
      return data.id_incarcare || data.idIncarcare || data.index_incarcare || data.uploadIndex || null
    },
    async checkEfacturaStatus (idIncarcare, cif) {
      const params = this.buildEfacturaQueryParams(cif)

      const response = await fetch(
        `${this.getEfacturaBaseUrl()}/efactura/status/${encodeURIComponent(idIncarcare)}?${params.toString()}`
      )

      const data = await this.parseEfacturaResponseBody(response)
      const normalized = this.normalizeEfacturaApiResponse(data, cif)

      if (!response.ok) {
        normalized.success = false
        normalized.pending = false
        if (!normalized.anafError) {
          normalized.anafError = this.parseAnafError(data, 'Nu s-a putut verifica statusul e-Factura.')
        }
      }

      return normalized
    },
    triggerXmlFileDownload (xml, filename) {
      const blob = new Blob([xml], { type: 'application/xml;charset=utf-8' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = filename
      link.click()
      URL.revokeObjectURL(link.href)
    },
    async downloadEfacturaXml (row) {
      if (!this.companyID) {
        swal({
          type: 'error',
          title: this.$t('general.error'),
          text: 'Lipsește compania selectată.',
          confirmButtonText: 'OK'
        })
        return
      }

      const invoice = row.rawInvoice
      if (!invoice) {
        swal({
          type: 'error',
          title: this.$t('general.error'),
          text: 'Datele facturii nu sunt disponibile.',
          confirmButtonText: 'OK'
        })
        return
      }

      const cif = this.getSpvCif(invoice)
      if (!cif) {
        swal({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați o locație cu CIF fiscal pentru generarea XML.',
          confirmButtonText: 'OK'
        })
        return
      }

      const invoiceLabel = `${row.series}-${row.invoiceNumber}`

      try {
        this.showSpvProgress(this.$t('gestiune.downloadEfacturaXml'), 'Se generează XML UBL...')

        const xml = await this.generateEfacturaXml(invoice, cif)

        swal.close()
        this.triggerXmlFileDownload(xml, `${invoiceLabel}.xml`)
      } catch (error) {
        console.error('Error downloading e-Factura XML:', error)
        swal.close()
        swal({
          type: 'error',
          title: this.$t('general.error'),
          text: error.message || 'Generarea XML UBL a eșuat.',
          confirmButtonText: 'OK'
        })
      }
    },
    async viewSpvPdf (row) {
      if (!row || !row.id) {
        swal({
          type: 'error',
          title: this.$t('general.error'),
          text: 'Factura nu are un identificator valid.',
          confirmButtonText: 'OK'
        })
        return
      }

      if (!this.companyID) {
        swal({
          type: 'error',
          title: this.$t('general.error'),
          text: 'Lipsește compania selectată.',
          confirmButtonText: 'OK'
        })
        return
      }

      if (!this.selectedLocation || !this.selectedLocation.inv_fiscal_code) {
        swal({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați o locație cu CIF fiscal pentru vizualizarea PDF SPV.',
          confirmButtonText: 'OK'
        })
        return
      }

      const invoiceLabel = `${row.series}-${row.invoiceNumber}`

      try {
        this.showSpvProgress(this.$t('gestiune.viewSpvPdf'), 'Se pregătește PDF-ul SPV...')

        const base = this.buildEfacturaPurchasePdfBaseUrl(row.id)
        const checkUrl = `${base}?${this.buildEfacturaPurchasePdfQueryParams({ check: '1' }).toString()}`

        swal.close()

        const result = await this.handleSpvInboxDownloadResponse(checkUrl, 'Eroare PDF SPV')

        if (!result) return

        if (result.status === true) {
          const pdfUrl = `${base}?${this.buildEfacturaPurchasePdfQueryParams().toString()}`
          window.open(pdfUrl, '_blank')
          return
        }

        const unavailableMessage = result.message || result.hint || result.eroare ||
          'PDF-ul SPV nu este disponibil pentru această factură.'

        this.showSpvSimpleAlert('info', `PDF SPV — ${invoiceLabel}`, unavailableMessage)
      } catch (error) {
        console.error('Error opening SPV PDF:', error)
        swal.close()
        swal({
          type: 'error',
          title: this.$t('general.error'),
          text: error.message || 'Eroare neașteptată la încărcarea PDF-ului SPV.',
          confirmButtonText: 'OK'
        })
      }
    },
    async sendToSPV (row) {
      if (!this.canSendToSpv(row)) {
        swal({
          type: 'info',
          title: this.$t('gestiune.sendToSPV'),
          text: 'Factura a fost deja trimisă în SPV sau este în procesare.',
          confirmButtonText: 'OK'
        })
        return
      }

      if (!this.companyID) {
        swal({
          type: 'error',
          title: this.$t('general.error'),
          text: 'Lipsește compania selectată.',
          confirmButtonText: 'OK'
        })
        return
      }

      const invoice = row.rawInvoice
      if (!invoice) {
        swal({
          type: 'error',
          title: this.$t('general.error'),
          text: 'Datele facturii nu sunt disponibile.',
          confirmButtonText: 'OK'
        })
        return
      }

      const cif = this.getSpvCif(invoice)
      if (!cif) {
        swal({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați o locație cu CIF fiscal pentru trimiterea în SPV.',
          confirmButtonText: 'OK'
        })
        return
      }

      const invoiceLabel = `${row.series}-${row.invoiceNumber}`

      const confirmResult = await this.openSpvSwal({
        title: ' ',
        html: `
          <div class="spv-prompt-card spv-prompt-card--confirm">
            <div class="spv-prompt-header">
              <span class="spv-prompt-logo">SPV</span>
              <div>
                <p class="spv-prompt-title">${this.escapeHtml(this.$t('gestiune.sendToSPV'))}</p>
                <p class="spv-prompt-subtitle">Factura <strong>${this.escapeHtml(invoiceLabel)}</strong></p>
              </div>
            </div>
            <p class="spv-prompt-question">Confirmați trimiterea facturii în SPV (ANAF)?</p>
          </div>
        `,
        customClass: 'spv-swal spv-swal--prompt spv-swal--confirm',
        showCancelButton: true,
        confirmButtonText: 'Trimite',
        cancelButtonText: this.$t('general.cancel') || 'Anulează'
      })

      if (!confirmResult) return

      const finalizeSpvFlow = async (result) => {
        try {
          await this.persistInvoiceSpvStatus(row, result)
        } catch (saveError) {
          console.error('Error saving SPV status on invoice document:', saveError)
        }

        await this.refreshInvoicesSpvStatuses(this.tableData)
      }

      try {
        this.showSpvProgress(
          this.$t('gestiune.sendToSPV'),
          `Se trimite factura ${invoiceLabel} în SPV (ANAF)...`
        )
        const xml = await this.generateEfacturaXml(invoice, cif)

        let result = await this.sendEfacturaDocument({ invoice, xml, cif })

        if (!result.success) {
          await finalizeSpvFlow(result)
          swal.close()
          this.showEfacturaAlert('error', 'Eroare trimitere SPV', result, invoiceLabel)
          return
        }

        if (result.idIncarcare) {
          const statusResult = await this.checkEfacturaStatus(result.idIncarcare, cif)
          result = this.mergeEfacturaResults(result, statusResult)

          if (!result.success) {
            await finalizeSpvFlow(result)
            swal.close()
            this.showEfacturaAlert('error', 'Eroare procesare SPV', result, invoiceLabel)
            return
          }

          if (this.isEfacturaStatusPending(result)) {
            await finalizeSpvFlow(result)
            swal.close()
            this.showEfacturaAlert('warning', 'Factură în procesare ANAF', result, invoiceLabel)
            return
          }
        }

        await finalizeSpvFlow(result)
        swal.close()
        this.showEfacturaAlert('success', this.$t('general.success'), result, invoiceLabel)
      } catch (error) {
        console.error('Error sending invoice to SPV:', error)
        await finalizeSpvFlow({
          success: false,
          anafError: error.message || 'Trimiterea în SPV a eșuat.'
        })
        swal.close()
        this.showEfacturaAlert('error', this.$t('general.error'), {
          success: false,
          cif,
          mode: this.getSpvMode(),
          standard: 'UBL',
          anafError: error.message || 'Trimiterea în SPV a eșuat.'
        }, invoiceLabel)
      }
    },
    async verifySpvStatus (row) {
      if (!this.companyID) {
        swal({
          type: 'error',
          title: this.$t('general.error'),
          text: 'Lipsește compania selectată.',
          confirmButtonText: 'OK'
        })
        return
      }

      const invoice = row.rawInvoice
      if (!invoice) {
        swal({
          type: 'error',
          title: this.$t('general.error'),
          text: 'Datele facturii nu sunt disponibile.',
          confirmButtonText: 'OK'
        })
        return
      }

      const cif = this.getSpvCif(invoice)
      if (!cif) {
        swal({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați o locație cu CIF fiscal pentru verificarea statusului SPV.',
          confirmButtonText: 'OK'
        })
        return
      }

      const idIncarcare = this.extractSpvIdIncarcareFromInvoice(invoice) || row.spvIdIncarcare
      if (!idIncarcare) {
        swal({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Factura nu are ID de încărcare SPV. Trimiteți factura în SPV mai întâi.',
          confirmButtonText: 'OK'
        })
        return
      }

      const invoiceLabel = `${row.series}-${row.invoiceNumber}`

      try {
        this.showSpvProgress(
          this.$t('gestiune.checkSpvStatus'),
          `Se verifică statusul ANAF (ID: ${idIncarcare})...`
        )

        const result = await this.checkEfacturaStatus(idIncarcare, cif)
        result.idIncarcare = result.idIncarcare || idIncarcare
        const spvMessageId = result.spvMessageId || result.idDescarcare || null

        swal.close()

        if (!result.success && !this.isEfacturaStatusPending(result)) {
          this.updateRowSpvStatus(row.id, 'error', idIncarcare, spvMessageId)
          this.showEfacturaAlert('error', 'Eroare status SPV', result, invoiceLabel)
          return
        }

        if (this.isEfacturaStatusPending(result)) {
          this.updateRowSpvStatus(row.id, 'pending', idIncarcare, spvMessageId)
          this.showEfacturaAlert('warning', 'Factură în procesare ANAF', result, invoiceLabel)
          return
        }

        this.updateRowSpvStatus(row.id, 'sent', idIncarcare, spvMessageId)
        this.showEfacturaAlert('success', this.$t('gestiune.checkSpvStatus'), result, invoiceLabel)
      } catch (error) {
        console.error('Error checking SPV status:', error)
        swal.close()
        this.showEfacturaAlert('error', this.$t('general.error'), {
          success: false,
          cif,
          mode: this.getSpvMode(),
          standard: 'UBL',
          idIncarcare,
          anafError: error.message || 'Verificarea statusului SPV a eșuat.'
        }, invoiceLabel)
      }
    },
    fetchNexusInvoiceStatus (row) {
      const orderId = row && row.orderNumber
      if (!orderId) return

      this.apiRequest(`/nexus/invoice/status/${orderId}`, 'GET', {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }, (response) => {
        if (response && response.status) {
          this.showNexusInvoiceStatusSwal(response.data != null ? response.data : response)
        } else {
          swal('', this.$t('validations.wentWrong'), 'error')
        }
      })
    },
    showNexusInvoiceStatusSwal (payload) {
      const status = Number(
        payload && (payload.nexus_invoice_status != null
          ? payload.nexus_invoice_status
          : payload.status)
      )
      const config = this.getNexusInvoiceStatusSwalConfig(status)
      swal({
        title: config.title,
        text: config.text,
        type: config.type
      })
    },
    getNexusInvoiceStatusSwalConfig (status) {
      const map = {
        1: { type: 'info', titleKey: 'nexus.invoiceStatus1', textKey: 'nexus.invoiceStatus1Text' },
        2: { type: 'info', titleKey: 'nexus.invoiceStatus2', textKey: 'nexus.invoiceStatus2Text' },
        3: { type: 'success', titleKey: 'nexus.invoiceStatus3', textKey: 'nexus.invoiceStatus3Text' },
        4: { type: 'error', titleKey: 'nexus.invoiceStatus4', textKey: 'nexus.invoiceStatus4Text' },
        5: { type: 'warning', titleKey: 'nexus.invoiceStatus5', textKey: 'nexus.invoiceStatus5Text' },
        6: { type: 'success', titleKey: 'nexus.invoiceStatus6', textKey: 'nexus.invoiceStatus6Text' },
        7: { type: 'error', titleKey: 'nexus.invoiceStatus7', textKey: 'nexus.invoiceStatus7Text' }
      }
      const item = map[status]
      if (!item) {
        return {
          type: 'info',
          title: this.$t('nexus.invoiceStatus'),
          text: this.$t('nexus.invoiceStatusUnknown')
        }
      }
      return {
        type: item.type,
        title: this.$t(item.titleKey),
        text: this.$t(item.textKey)
      }
    },
    fetchNexusInvoiceLogs (row) {
      const orderId = row && row.orderNumber
      if (!orderId) return

      this.apiRequest(`/nexus/invoice/logs/${orderId}`, 'GET', {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }, (response) => {
        if (response && response.status) {
          swal({
            title: this.$t('nexus.invoiceLog'),
            html: `<pre style="text-align:left;max-height:400px;overflow:auto;">${JSON.stringify(response.data != null ? response.data : response, null, 2)}</pre>`
          })
        } else {
          swal('', this.$t('validations.wentWrong'), 'error')
        }
      })
    },
    markNexusInvoice (row) {
      const orderId = row && row.orderNumber
      if (!orderId) return

      const action = row.hasParent ? 'storno' : 'send'
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        order_id: orderId,
        action
      }

      if (action === 'send') {
        data.invoice_series = row.series
        data.invoice_number = row.invoiceNumber
      }

      this.apiRequest('/nexus/invoice/mark', 'POST', data, (response) => {
        if (response && response.status) {
          swal('', this.$t('nexus.invoiceMarkSuccess'), 'success')
        } else {
          swal('', this.$t('validations.wentWrong'), 'error')
        }
      })
    },
    async getInvoices (series = '', tip = 'invoice', location = null, page = 1, pageSize = 25) {
      const externalCompanyId = this.companyID

      this.loading = true

      if (!externalCompanyId) {
        return
      }

      let url = `${process.env.API_BASE_URL_GESTIUNE}:4443/documents?externalCompanyId=${externalCompanyId}&tip=${tip}`
      if (series) {
        url += `&series=${series}`
      }

      url += `&page=${page}&limit=${pageSize}`

      if (location) {
        if (Array.isArray(location.locations)) {
          const ids = location.locations.map(l => l.true_id).filter(Boolean)
          for (const id of ids) {
            url += `&externalLocationId=${encodeURIComponent(id)}`
          }
        } else if (location.id) {
          if (location.true_id) {
            url += `&externalLocationId=${encodeURIComponent(location.true_id)}`
          }
          // if (location.inv_fiscal_code) {
          //   url += `&vatNumber=${encodeURIComponent(location.inv_fiscal_code)}`
          // }
        }
      } else {
        const allLocations = this.groupedLocations.flatMap(group => group.locations)
        const ids = allLocations.map(l => l.true_id).filter(Boolean)
        for (const id of ids) {
          url += `&externalLocationId=${encodeURIComponent(id)}`
        }
      }

      clearTimeout(this.loadingTimeout)
      this.loadingTimeout = setTimeout(() => {
        this.loading = true
      }, 100)
      try {
        const response = await fetch(url)
        const data = await response.json()
        if (Array.isArray(data.documents)) {
          clearTimeout(this.loadingTimeout)
          this.loading = false

          this.totalItems = data.total || 0
          this.currentPage = data.currentPage || page
          this.pageSize = data.pageSize || pageSize

          this.tableData = data.documents.map(invoice => {
            let vatValue = 0
            if (invoice.vatTotals && typeof invoice.vatTotals === 'object') {
              vatValue = Object.values(invoice.vatTotals).reduce((sum, val) => sum + val, 0)
            }

            const orderInfo = this.extractOrderInfoFromInvoice(invoice)

            const row = {
              id: invoice._id || invoice.id,
              invoiceNumber: invoice.invoiceNumber,
              client: invoice.customer ? invoice.customer.name : 'N/A',
              issueDate: invoice.date,
              valueNoVAT: (invoice.subtotal).toFixed(2) + ' ' + invoice.currency,
              vatValue: vatValue.toFixed(2) + ' ' + invoice.currency,
              totalValue: (invoice.total).toFixed(2) + ' ' + invoice.currency,
              series: invoice.series || 'N/A',
              hasParent: !!invoice.parentDocument,
              orderDate: orderInfo.orderDate,
              orderNumber: orderInfo.orderNumber,
              bonData: orderInfo.bonData,
              bonNumber: orderInfo.bonNumber,
              paymentType: orderInfo.paymentType,
              orderInfoDisplay: orderInfo.orderNumber || orderInfo.bonNumber || '',
              hasOrderInfo: !!(
                orderInfo.orderDate ||
                orderInfo.orderNumber ||
                orderInfo.bonData ||
                orderInfo.bonNumber ||
                orderInfo.paymentType
              ),
              _orderInfoLoading: false,
              rawInvoice: invoice
            }

            return row
          }).map(row => this.applySpvStatusToRow(row, row.rawInvoice))

          await this.refreshInvoicesSpvStatuses(this.tableData)
        } else {
          console.error('Invalid data format:', data)
        }
      } catch (error) {
        console.error('Error fetching invoices:', error)
      }
    },
    async downloadExcel (row) {
      const series = row.series
      const invoiceNumber = row.invoiceNumber
      const externalCompanyId = this.companyID

      if (!series || !invoiceNumber || !externalCompanyId) {
        alert('Missing series, invoice number or company ID.')
        return
      }

      const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/invoice/${series}-${invoiceNumber}/xls?externalCompanyId=${externalCompanyId}`

      try {
        const response = await fetch(url)
        if (response.ok) {
          const blob = await response.blob()
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `${series}-${invoiceNumber}.xls`
          link.click()
          URL.revokeObjectURL(link.href)
        } else {
          console.error('Error downloading invoice:', response.statusText)
        }
      } catch (error) {
        console.error('Error fetching invoice:', error)
      }
    },
    async downloadInvoice (row) {
      const series = row.series
      const invoiceNumber = row.invoiceNumber
      const externalCompanyId = this.companyID

      if (!series || !invoiceNumber) {
        alert('Missing series or invoice number.')
        return
      }

      const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/invoice/${series}-${invoiceNumber}/pdf?externalCompanyId=${externalCompanyId}`

      try {
        const response = await fetch(url)
        if (response.ok) {
          const blob = await response.blob()
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `${series}-${invoiceNumber}.pdf`
          link.click()
          URL.revokeObjectURL(link.href)
        } else {
          console.error('Error downloading invoice:', response.statusText)
        }
      } catch (error) {
        console.error('Error fetching invoice:', error)
      }
    },
    async handleDeleteInvoice (id) {
      console.log(id)
      if (!id) {
        console.error('Missing Invoice ID for deletion.')
        return
      }

      const row = this.tableData.find(item => item.id === id)
      const rowIndex = row ? this.tableData.indexOf(row) : -1

      if (!row || rowIndex !== 0) return

      const status = this.normalizeSpvStatusKey(
        row.spvStatus || row.rawInvoice.spvStatus || this.resolveSpvStatusFromInvoice(row.rawInvoice)
      )

      if (status === 'sent' || status === 'pending') {
        swal({
          type: 'info',
          title: this.$t('general.delete'),
          text: status === 'pending'
            ? 'Factura în procesare SPV nu poate fi ștearsă.'
            : 'Factura trimisă în SPV nu poate fi ștearsă.',
          confirmButtonText: 'OK'
        })
        return
      }

      swal({
        title: 'Ești sigur?',
        text: 'Această acțiune va șterge definitiv factura!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Da, șterge!',
        cancelButtonText: 'Anulează'
      }).then(async (result) => {
        if (result) {
          try {
            const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/remove`, {
              method: 'DELETE',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                type: 'invoice',
                id: id,
                externalCompanyId: this.companyID
              })
            })

            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`)

            const data = await response.json()
            console.log('Invoice deleted successfully:', data)

            swal({
              title: 'Succes!',
              text: 'Factura a fost ștearsă cu succes.',
              type: 'success',
              timer: 2000,
              showConfirmButton: false
            })

            this.getInvoices()
          } catch (error) {
            console.error('Error deleting Invoice:', error)

            swal({
              title: 'Eroare!',
              text: 'A apărut o problemă la ștergerea facturii.',
              type: 'error',
              timer: 2000,
              showConfirmButton: false
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.tableInvoice .el-table .cell {
  height: auto;
  min-height: 56px;
  display: flex;
  align-items: center;
}

.tableInvoice .invoice-actions-column .cell {
  justify-content: center;
}

.tableInvoice .order-info-column .cell {
  justify-content: flex-start;
}
.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Aliniază butoanele pe axa verticală */
  margin-bottom: 15px;
}
.el-dropdown-menu {
  min-width: 140px;
  font-size: 14px;
}
.arrow-box {
  display: inline-block;
  font-size: 18px; /* mărimea săgeții */
  padding: 4px 6px; /* spațiu în jurul săgeții */
  border: 1px solid #674BD2 !important; /* border violet */
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  user-select: none;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
  color: #674BD2; /* culoare săgeată */
}

.arrow-box:hover {
  background-color: #674BD2 !important; /* background violet la hover */
  border-color: #674BD2 !important;
  color: #fff !important; /* săgeata devine albă */
}

/* Dropdown menu */
.custom-dropdown-menu {
  min-width: 150px;
  font-size: 14px;
}
.el-dropdown-item {
  padding: 6px 12px;
}

.disabled {
  pointer-events: none;
  opacity: 0.5;
}
.left-buttons {
  display: flex;
  align-items: center;
}
.downl {
  background: green !important;
  max-width: fit-content !important;
}
.left-buttons button{
  display: flex;
  align-items: center;
  padding-top: 10px;
}

.left-buttons el-button {
  margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
  margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}

.button-group {
  display: flex; /* Folosește flexbox pentru alinierea orizontală */
  justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
    margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
    margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}

.right-buttons button.spv-fetch {
  background-color: #2563eb !important;
  border: 1px solid #2563eb !important;
  padding: 7px 15px !important;
  border-radius: 50px !important;
  font-size: 14px;
  font-weight: 400;
  line-height: 2;
  color: #fff !important;
  text-transform: initial;
}

.right-buttons button.spv-fetch:hover {
  background-color: #1d4ed8 !important;
  border-color: #1d4ed8 !important;
  opacity: 1;
}

.el-pagination {
  text-align: center !important;
}

.order-info-col-header {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin-left: 6px;
  border-radius: 50%;
  background: rgba(255, 142, 0, 0.14);
  color: #ff8e00;
  font-size: 12px;
  vertical-align: middle;
}

.order-info-cell {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
}

.order-info-number {
  font-size: 13px;
  font-weight: 600;
  color: #25396F;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.order-info-number--empty {
  color: #c0c8d4;
  font-weight: 400;
}

.invoice-actions-header {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  white-space: nowrap;
}

.invoice-actions-cell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.order-info-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid #d7dce5;
  border-radius: 50%;
  background: #fff;
  color: #a0aec0;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
  flex-shrink: 0;
}

.order-info-trigger--active {
  border-color: rgba(255, 142, 0, 0.45);
  background: linear-gradient(135deg, #fffaf4 0%, #fff 100%);
  color: #ff8e00;
}

.order-info-trigger--loading {
  opacity: 0.6;
  pointer-events: none;
}

.order-info-trigger--active:hover,
.order-info-trigger--active:focus {
  background: linear-gradient(135deg, #ff8e00 0%, #ff7300 100%);
  border-color: #ff8e00;
  color: #fff;
  outline: none;
  box-shadow: 0 4px 12px rgba(255, 142, 0, 0.28);
}
</style>

<style>
/* SPV SweetAlert shell */
.spv-swal.swal2-popup,
.spv-swal {
  border-radius: 16px !important;
  padding: 24px 24px 18px !important;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.16) !important;
}

.spv-swal .swal2-title,
.spv-swal .swal2-content {
  color: #0f172a !important;
}

.spv-swal--result .swal2-icon,
.spv-swal--inbox .swal2-icon,
.spv-swal--prompt .swal2-icon,
.spv-swal--progress .swal2-icon {
  display: none !important;
}

.spv-swal--prompt .swal2-title,
.spv-swal--inbox .swal2-title {
  display: none !important;
}

.spv-swal-btn {
  border: none !important;
  border-radius: 999px !important;
  padding: 10px 24px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  box-shadow: none !important;
  margin: 0 6px !important;
}

.spv-swal .swal-button--confirm,
.spv-swal .swal2-confirm {
  background: #674BD2 !important;
  color: #fff !important;
  border-radius: 999px !important;
  opacity: 1 !important;
  font-weight: 600 !important;
  min-width: 96px;
  box-shadow: 0 4px 12px rgba(103, 75, 210, 0.32) !important;
}

.spv-swal .swal-button--confirm:hover,
.spv-swal .swal2-confirm:hover,
.spv-swal .swal2-confirm:focus {
  background: #5638c4 !important;
  color: #fff !important;
}

.spv-swal-btn--confirm {
  background: #674BD2 !important;
  color: #fff !important;
}

.spv-swal-btn--confirm:hover,
.spv-swal-btn--confirm:focus {
  background: #5638c4 !important;
  color: #fff !important;
}

.spv-swal-btn--cancel {
  background: #f1f5f9 !important;
  color: #475569 !important;
}

.spv-swal-btn--cancel:hover,
.spv-swal-btn--cancel:focus {
  background: #e2e8f0 !important;
  color: #334155 !important;
}

.spv-swal .swal-button--cancel,
.spv-swal .swal2-cancel {
  background: #f1f5f9 !important;
  color: #475569 !important;
  border-radius: 999px !important;
}

/* Prompt cards */
.spv-prompt-card {
  text-align: left;
  padding: 4px 2px 0;
}

.spv-prompt-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
}

.spv-prompt-logo,
.spv-inbox-logo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.5px;
  flex-shrink: 0;
  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.28);
}

.spv-prompt-title,
.spv-inbox-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
}

.spv-prompt-subtitle {
  margin: 4px 0 0;
  font-size: 13px;
  color: #64748b;
  line-height: 1.4;
}

.spv-prompt-select {
  border-radius: 10px !important;
  border: 1px solid #cbd5e1 !important;
  padding: 10px 12px !important;
  font-size: 14px !important;
  background: #fff !important;
}

.spv-prompt-question {
  margin: 0;
  padding: 12px 14px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #334155;
  font-size: 14px;
  line-height: 1.5;
}

.spv-prompt-card--confirm .spv-prompt-question {
  margin-top: 4px;
}

/* Progress */
.spv-progress {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 8px 0 4px;
}

.spv-progress-spinner {
  width: 42px;
  height: 42px;
  border: 3px solid #dbeafe;
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: spv-spin 0.8s linear infinite;
}

.spv-progress-text {
  margin: 0;
  font-size: 14px;
  color: #475569;
  text-align: center;
  line-height: 1.5;
}

.spv-progress-title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  text-align: center;
  line-height: 1.3;
}

@keyframes spv-spin {
  to { transform: rotate(360deg); }
}

/* Inbox header */
.spv-inbox-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e2e8f0;
}

.spv-inbox-header--empty {
  margin-bottom: 12px;
}

.spv-inbox-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.spv-inbox-chip {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.spv-inbox-chip--primary {
  background: #dbeafe;
  color: #1d4ed8;
}

.spv-inbox-chip--muted {
  background: #f1f5f9;
  color: #64748b;
}

.spv-inbox-empty-msg {
  padding: 14px 16px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  color: #64748b;
  font-size: 14px;
  line-height: 1.5;
}

/* Result header */
.spv-result-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border-radius: 12px;
  margin-bottom: 16px;
}

.spv-result-header--success {
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  border: 1px solid #a7f3d0;
}

.spv-result-header--error {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 1px solid #fecaca;
}

.spv-result-header--pending {
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  border: 1px solid #fde68a;
}

.spv-result-header-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  flex-shrink: 0;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 18px 18px;
}

.spv-result-header--success .spv-result-header-icon {
  background-color: #10b981;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'/%3E%3C/svg%3E");
}

.spv-result-header--error .spv-result-header-icon {
  background-color: #ef4444;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cline x1='18' y1='6' x2='6' y2='18'/%3E%3Cline x1='6' y1='6' x2='18' y2='18'/%3E%3C/svg%3E");
}

.spv-result-header--pending .spv-result-header-icon {
  background-color: #f59e0b;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='12' cy='12' r='9'/%3E%3Cpolyline points='12 7 12 12 15 14'/%3E%3C/svg%3E");
}

.spv-result-header-body {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.spv-result-header-body strong {
  font-size: 15px;
  color: #0f172a;
  line-height: 1.3;
}

.spv-result-header-body span {
  font-size: 13px;
  color: #64748b;
}

.custom-dropdown-menu .el-dropdown-menu__item.disabled {
  pointer-events: none;
  opacity: 0.5;
  color: #999 !important;
  font-weight: bold;
}

.spv-result-card {
  text-align: left;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
}

.spv-result-badge {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 14px;
}

.spv-result-badge--success {
  background: #e8f7ee;
  color: #1e7e45;
}

.spv-result-badge--error {
  background: #fdecea;
  color: #c0392b;
}

.spv-result-badge--pending {
  background: #fff8e6;
  color: #b7791f;
}

.spv-result-message--pending {
  background: #fff8e6;
  border: 1px solid #f6e05e;
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 14px;
}

.spv-result-details {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 14px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.spv-result-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 0;
  border-bottom: 1px solid #eceff4;
}

.spv-result-row:last-child {
  border-bottom: none;
}

.spv-result-label {
  color: #666;
  flex: 0 0 42%;
}

.spv-result-value {
  color: #222;
  font-weight: 600;
  text-align: right;
  word-break: break-word;
}

.spv-result-value--with-action {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}

.spv-result-download-btn {
  font-size: 11px;
  padding: 4px 8px;
  white-space: nowrap;
}

.spv-result-message {
  border-radius: 8px;
  padding: 12px 14px;
  margin-bottom: 12px;
}

.spv-result-message--error {
  background: #fff5f5;
  border: 1px solid #f5c2c0;
}

.spv-result-message--success {
  background: #f3fbf6;
  border: 1px solid #b8e0c4;
}

.spv-result-message-title {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 8px;
  color: #555;
}

.spv-result-message p {
  margin: 0;
  color: #222;
}

.spv-result-errors {
  margin: 0;
  padding-left: 18px;
  color: #c0392b;
}

.spv-result-errors li {
  margin-bottom: 4px;
}

.spv-result-hint {
  background: #fffbea;
  border: 1px solid #f0dfa8;
  border-radius: 8px;
  padding: 10px 12px;
  color: #7a6221;
}

.spv-inbox-card {
  text-align: left;
  font-size: 13px;
  line-height: 1.45;
  color: #333;
}

.spv-inbox-title {
  margin: 0 0 8px;
  font-size: 15px;
  font-weight: 600;
  color: #222;
}

.spv-inbox-info {
  margin: 0 0 8px;
  color: #555;
}

.spv-inbox-meta {
  margin: 0 0 12px;
  color: #666;
  font-size: 12px;
}

.spv-inbox-table-wrap {
  max-height: 420px;
  overflow: auto;
  border: 1px solid #e8ebf0;
  border-radius: 8px;
}

.spv-inbox-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
}

.spv-inbox-table thead th {
  position: sticky;
  top: 0;
  background: #f4f6f9;
  color: #555;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  text-align: left;
  padding: 10px 12px;
  border-bottom: 1px solid #e8ebf0;
  white-space: nowrap;
}

.spv-inbox-table tbody td {
  padding: 10px 12px;
  border-bottom: 1px solid #f0f2f5;
  vertical-align: top;
  color: #222;
}

.spv-inbox-table tbody tr:last-child td {
  border-bottom: none;
}

.spv-inbox-table tbody tr:hover {
  background: #fafbfc;
}

.spv-inbox-details {
  min-width: 220px;
  max-width: 320px;
  word-break: break-word;
}

.spv-inbox-actions {
  white-space: nowrap;
  width: 1%;
}

.spv-inbox-download-btn {
  border: 1px solid #d0d7e2;
  background: #fff;
  color: #334155;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.spv-inbox-download-btn:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #94a3b8;
}

.spv-inbox-download-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.spv-inbox-tip {
  display: inline-block;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.spv-inbox-tip--error {
  background: #fdecea;
  color: #c0392b;
}

.spv-inbox-tip--received {
  background: #e8f4fd;
  color: #1f6fb2;
}

.spv-inbox-tip--sent {
  background: #e8f7ee;
  color: #1e7e45;
}

.spv-inbox-tip--default {
  background: #f1f3f5;
  color: #555;
}

.spv-status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
}

.spv-status-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.spv-status-index-badge {
  display: inline-block;
  padding: 3px 9px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.3;
  background: #eef2ff;
  color: #4338ca;
  border: 1px solid #c7d2fe;
  word-break: break-all;
}

.spv-status--none {
  background: #f3efff;
  color: #674bd2;
}

.spv-status--sent {
  background: #e8f7ee;
  color: #18804a;
}

.spv-status--error {
  background: #ffe8e8;
  color: #d92d20;
}

.spv-status--pending {
  background: #fff3e0;
  color: #e65100;
}

.invoice-order-info-popover {
  border-radius: 10px !important;
  border: 1px solid #e8edf5 !important;
  box-shadow: 0 10px 28px rgba(37, 57, 111, 0.12) !important;
  padding: 0 !important;
}

.invoice-order-info-popover-content {
  padding: 12px 14px 14px;
}

.invoice-order-info-popover-title {
  font-size: 13px;
  font-weight: 700;
  color: #25396F;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #edf1f7;
}

.invoice-order-info-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 0;
  border-bottom: 1px solid #f3f6fa;
}

.invoice-order-info-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.invoice-order-info-item--highlight .invoice-order-info-value {
  color: #ff8e00;
}

.invoice-order-info-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #8a97ad;
}

.invoice-order-info-value {
  font-size: 13px;
  font-weight: 700;
  color: #25396F;
  word-break: break-word;
}

.spv-swal--order-info .swal2-title {
  display: none !important;
}

.invoice-order-info-card {
  text-align: left;
}

.invoice-order-info-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e8edf5;
}

.invoice-order-info-card-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, #ff8e00 0%, #ff7300 100%);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  flex-shrink: 0;
}

.invoice-order-info-card-title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #25396F;
}

.invoice-order-info-card-subtitle {
  margin: 3px 0 0;
  font-size: 12px;
  color: #7a8ba8;
}

.invoice-order-info-card-body {
  background: #f8fafd;
  border: 1px solid #edf1f7;
  border-radius: 10px;
  padding: 4px 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Invoice/InvoiceDashboard.vue